/** 收件人证件类型 */
export enum CONSIGNEE_ID_TYPE {
  /**身份证 */
  idCard = '1',
  /**2护照 */
  passpord = '2',
  /**3港澳通行证 */
  gangAoTongXingZheng = '3',
  /**4回乡证*/
  huiXiangZheng = '4',
  /**5台胞证 */
  taiBaozheng = '5',
  /**6赴台通行证 */
  fuTaiTongXingZheng = '6',
  /**7其它 */
  other = '7',
}

// 支持店配的国家和地区
export const STORE_COUNTRY = ['SG', 'MY', 'HK', 'MO', 'TH']

/**
 * 711跨境不需要英文姓名的国家和地区
 */
export const CROSS_NOT_NEED_EN_NAME = ['SG', 'MY', 'HK', 'MO', 'TH']

// 订单商品类型
export const ORDER_SKU_TYPE = {
  // 组合商品
  GROUP: 'sku_group',
  // 普通商品
  SKU: 'sku',
}

export const SYNC_MAX_COUNT = 100

/** 出库类型 */
export const OUT_BOUND_TYPE = {
  /** 销售出库 */
  SALES: 'sales',
  /** 不良品出库 */
  BAD: 'bad',
}

/** 出库类型 */
export const OUTBOUND_TYPE_TO_STOCKTYPE = {
  /** 销售出库 */
  sales: 'good',
  /** 不良品出库 */
  bad: 'bad',
}

/** 订单错误类型- 上游错误*/
export const ORIGIN_ERROR = 'origin_error'
